module.exports = __webpack_public_path__ + "it.svg?3fd8e0de78b89e35b99954e155067480";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/it.svg
// module id = 1092
// module chunks = 27